/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import { HOUSE, WOOD, PERFORMANCE } from './page/house'
import ABOUTUS from './page/aboutus'
import RECRUIT from './page/recruit'
import TAGGED from './modules/tagged_content'
import GALLERIES from './page/galleries'
import SPECIAL from './page/special'
import TOPICS from './page/topics'


/*****
 * サイト設定
 */
window.siteinfo = {
  mapApiKeys: {
    'local':          'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'www.ishimaki.com': 'AIzaSyCnoRIj2niYmUyOXVsFywFaNvlyIZVSCTk' //production
  }
}

const loader = (w, d, l) => {
  // 条件分岐のためのURL正規化
  let md, key, id
  md = w.query_string('mode')
  id = w.query_string('article')
  if( md == 'detail' ) key = 'article'
  else if( md == 'list' && id ) key = 'cat'
  let path = l.pathname.replace('main.php','')
  let request = ( md && key && id )? path + `?mode=${md}&${key}=${id}`: path

  switch( request ){
    case '/house/':
    case '/house/?mode=detail&article=1':
    case '/house/?mode=detail&article=2':
    case '/house/?mode=detail&article=3':
    case '/house/?mode=detail&article=4':
    case '/house/?mode=detail&article=5':
    case '/house/?mode=detail&article=6':
      HOUSE(); break
    case '/house/?mode=detail&article=7':
    case '/house/?mode=detail&article=8':
      WOOD(); break
    case '/house/?mode=detail&article=9':
    case '/house/?mode=detail&article=10':
    case '/house/?mode=detail&article=11':
      PERFORMANCE(); break
  }
  switch( path ){
    case '/': HOME(); break
    case '/aboutus/': ABOUTUS(); break
    case '/recruit/': RECRUIT(); break
    case '/galleries/':
      TAGGED()
      GALLERIES()
      break
    case '/special/':
      TAGGED()
      SPECIAL()
      break
    case '/topics/': 
      TAGGED()
      TOPICS()
      break
    }
}

/*****
 * サイト初期化
 */
INIT()
loader( window, document, location )